import Field from "@/Field";
import IconButton from "@/IconButton";
import { SearchOutlined } from "@spoctech/icons";

const SearchBox = () => {
  return (
    <Field
      placeholder="What would you like to learn?"
      className="!mb-0"
      wrapperclassName="h-10"
      endAdornment={
        <IconButton title="search">
          <SearchOutlined />
        </IconButton>
      }
    />
  );
};

export default SearchBox;
